import React, { useState, useEffect } from "react";

import Header from "../../components/header/header";
import { useNavigate, useLocation } from "react-router-dom";
import "./bookingPayment.css";
import BookingFooter from "../../components/bookingFooter/bookingFooter";
import RideSummary from "../../components/rideSummary/rideSummary";
import ReactGA from "react-ga4";
const BookingPayment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const receivedData = location.state || {};

  const [isLoading, setIsLoading] = useState(false);
  const gtag_report_conversion = () => {
    ReactGA.event({
      category: "Conversion",
      action: "bookingCreated", // or any relevant action
      label: "TripCreated",
      value: 1, // Optional: any numeric value you want to associate with this event
      nonInteraction: false,
      send_to: "AW-16812740540/zs8rCKrQ3vgZELyf-NA-", // Important for Google Ads conversions
    });
  };
  const onContinueClick = async () => {
    setIsLoading(true);
    try {
      const requestData = {
        ...receivedData,
        paymentMode: "cash",
      };

      const response = await fetch(
        "https://api.velocitylimousinedubai.com/trip",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit booking");
      }
      const data = await response.json();
      console.log("Booking successful:", data);
      gtag_report_conversion();
      navigate("/booking-confirm");
    } catch (error) {
      console.error("Error submitting booking:", error);
      alert("Booking failed. Please try again.");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scroll = window.scrollY; // Get the current scroll position
      const element = document.querySelector("header");
      if (element) {
        if (scroll >= 10) {
          element.classList.add("lightHeader");
        } else {
          document.querySelector("header").classList.remove("lightHeader");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll); // Cleanup the event listener on unmount
    };
  }, []);

  return (
    <>
      <Header></Header>
      <div className="content_">
        {/* Content Inner */}
        <div className="content__inner">
          <div className="overflow-hidden">
            {/* Multi-steps Form */}
            <div className="multisteps-form">
              <div className="progress-row">
                {/* Progress Bar */}
                <div className="row">
                  <div className="col-12 col-lg-12 ml-auto mr-auto mb-4 mt-5">
                    <div className="multisteps-form__progress flex space-x-4">
                      <button
                        className="multisteps-form__progress-btn bg-blue-500  js-active text-white py-2 px-4 rounded"
                        type="button"
                        title="Service Class"
                      >
                        <span>Service Class</span>
                      </button>
                      <button
                        className="multisteps-form__progress-btn bg-gray-200 js-active   text-gray-700 py-2 px-4 rounded hover:bg-blue-500 hover:text-white transition"
                        type="button"
                        title="Pickup Info"
                      >
                        <span>Pickup Info</span>
                      </button>
                      {/* Commented Button */}
                      {/* <button className="multisteps-form__progress-btn" type="button" title="Log In">
                    <span>Log In</span>
                </button> */}
                      <button
                        className="multisteps-form__progress-btn bg-gray-200  js-active text-gray-700 py-2 px-4 rounded hover:bg-blue-500 hover:text-white transition"
                        type="button"
                        title="Payment"
                      >
                        <span>Payment</span>
                      </button>
                      <button
                        className="multisteps-form__progress-btn bg-gray-200 text-gray-700 py-2 px-4 rounded hover:bg-blue-500 hover:text-white transition"
                        type="button"
                        title="Thankyou"
                      >
                        <span>Thank You</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-8 m-auto">
                  <form class="multisteps-form__form">
                    <div
                      className="multisteps-form__panel rounded js-active"
                      data-animation="scaleIn"
                    >
                      <div className="step_details mb-5">
                        <input
                          type="hidden"
                          name="vehicleType"
                          id="vehicleType"
                          value="Comfort"
                        />
                        <RideSummary
                          pickup={receivedData.pickupLocation}
                          destination={receivedData.dropOffLocation}
                          pickupDate={receivedData.pickupDate}
                          pickupTime={receivedData.pickupTime}
                          distDurationValue={receivedData.distDurationValue}
                        ></RideSummary>

                        <h3 className="additional-heading mt-4 mb-3">
                          Payment Method
                        </h3>
                        <div className="payment-section">
                          <label className="payment-option mt-1">
                            <div className="option-details">
                              <small>
                                Cash on Arrival (Card / Payment Link / Cash)
                              </small>
                              <span>
                                <input
                                  type="radio"
                                  name="paymentMode"
                                  value="cash"
                                  defaultChecked
                                />
                                No Additional Fees
                              </span>
                            </div>
                          </label>

                          <div className="terms">
                            <label>
                              <input type="checkbox" defaultChecked /> I accept
                              the
                              <a href="terms.html"> Terms & Conditions</a>
                            </label>
                            <label>
                              <input type="checkbox" defaultChecked /> I want to
                              subscribe to the newsletter (Tour Tips and Special
                              Deals).
                            </label>
                          </div>
                        </div>

                        <div className="pickup-sign border rounded p-3 mt-4 d-none">
                          <div className="input-block">
                            <div className="value_wrapper">
                              <span className="label-box">Name on card *</span>
                              <input className="inputElement" type="text" />
                            </div>
                          </div>

                          <div className="input-block">
                            <div className="value_wrapper">
                              <span className="label-box">Card number *</span>
                              <input className="inputElement" type="text" />
                            </div>
                          </div>

                          <div className="input-block">
                            <div className="value_wrapper">
                              <span className="label-box">
                                Expiration date *
                              </span>
                              <input className="inputElement" type="month" />
                            </div>
                          </div>

                          <div className="input-block">
                            <div className="value_wrapper">
                              <span className="label-box">CVV *</span>
                              <input className="inputElement" type="number" />
                            </div>
                          </div>

                          <div className="d-flex justify-content-between my-4">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="flexCheckChecked1"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexCheckChecked1"
                              >
                                Cash On Delivery
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="flexCheckChecked2"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexCheckChecked2"
                              >
                                Save card to your list
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="all_include">
                          <ul>
                            <li>
                              <span>
                                <svg
                                  role="img"
                                  aria-label="Icon/done"
                                  className="remixicon-icon InfoList_icon__K7lI0 _default_rs803_65"
                                  width="20px"
                                  height="20px"
                                  fill="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z" />
                                </svg>
                              </span>
                              Our servers are encrypted with TLS/SSL to ensure
                              security and privacy.
                            </li>
                            {/* <li>
                              <span>
                                <svg
                                  role="img"
                                  aria-label="Icon/done"
                                  className="remixicon-icon InfoList_icon__K7lI0 _default_rs803_65"
                                  width="20px"
                                  height="20px"
                                  fill="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z" />
                                </svg>
                              </span>
                              The amount will be held from your selected payment
                              method after the booking. We only charge you after
                              the ride is finished.
                            </li> */}
                          </ul>
                        </div>
                      </div>
                      <BookingFooter
                        onContinueClick={() => onContinueClick()}
                        isLoading={isLoading}
                      ></BookingFooter>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookingPayment;
